import { useEffect, useState } from "react";
import axios from 'axios';
import Popup from "../HelperComponents/Popup";

const FacultyAdminPage = ({ CurrentUser }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [popUp, setPopUp] = useState(0);
    const [allFaculty, setAllFaculty] = useState([]); //List of all faculty
    const [faculty, setFaculty] = useState({}); //For Add/Mod/Del

    const emptyFaculty = {
        pid: "",
        first: "",
        last: "",
        email: "",
        cs_department: false,
    }

    /** Initial page loading */
    useEffect(() => {
        if(!isLoaded) {
            setUp();
        }
    }, [])

    const setUp = async() => {
        await getFaculty();
        setIsLoaded(true);
    }

    async function getFaculty() {
        axios.get("/api/faculty").then((response) => {
            setAllFaculty(response.data.faculty);
        }).catch((error) => {
            if (error.response) {
                console.error('Error getting faculty:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error getting faculty, \nContact an admin if this persists.`);
            setAllFaculty([]);
        });
    }

    function handleChange(event) {
        const {name, type, value, checked} = event.target;
        //console.log(`${[name]}: ${type === 'checkbox' ? checked : value}`)
        setFaculty(f => ({
            ...f,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    function popUpSetUp(pid, mode) {
        if(mode < 2) { //Empty faculty for close or add
            setFaculty({...emptyFaculty});
        } else { //Populate faculty for mod or delete
            setFaculty(allFaculty.find(f => f.pid === pid));
        }
        setPopUp(mode);
    }

    function handleSubmit(event) {
        event.preventDefault();
        if(popUp === 1 || popUp === 2) {
            axios.post(
                "/api/faculty",
                faculty
            ).then((result) => {
                console.log(result);
                getFaculty().then(() => {
                    setPopUp(0);
                    setFaculty({...emptyFaculty});
                });
            }).catch((error) => {
                if (error.response) {
                    console.error(`Error ${popUp === 1 ? "adding" : "modifying"} faculty:`, error.response);
                } else if (error.request) {
                    console.error(`Got no response to request:`, error.request);
                } else {
                    console.error('Error:', error.message)
                }
                alert(`Error ${popUp === 1 ? "adding" : "modifying"} faculty, \nContact an admin if this persists.`);
            });
        } else if(popUp === 3) {
            axios.delete(
                `/api/faculty/${faculty.pid}`
            ).then(() => {
                setPopUp(0);
                setFaculty({...emptyFaculty});
                getFaculty().then(() => {
                    setPopUp(0);
                    setFaculty({...emptyFaculty});
                });
            }).catch((error) => {
                if (error.response) {
                    console.error(`Error deleting faculty:`, error.response);
                } else if (error.request) {
                    console.error(`Got no response to request:`, error.request);
                } else {
                    console.error('Error:', error.message)
                }
                alert(`Error deleting faculty, \nContact an admin if this persists.`);
            });
        } else {
            alert("Quit breaking things!");
        }
    }

    return (
        <div className="faculty-admin-page">
            <h1>Faculty Administration</h1>
            <button
                type="button"
                className="btn btn-success"
                onClick={() => popUpSetUp("",1)}
            >Add Faculty</button>
            <table className="table">
                <thead>
                    <tr>
                        <th>PID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>CS Faculty</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {allFaculty.map((f) => (
                        <tr>
                            <td>{f.pid}</td>
                            <td>{f.first}</td>
                            <td>{f.last}</td>
                            <td>{f.email}</td>
                            <td>{f.cs_department}</td>
                            <td>
                                <button
                                    type="button"
                                    className="btn btn-warning"
                                    onClick={() => popUpSetUp(f.pid, 2)}
                                    disabled={f.pid === CurrentUser.pid}
                                >Modify</button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => popUpSetUp(f.pid, 3)}
                                    disabled={f.pid === CurrentUser.pid}
                                >Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {popUp > 0 &&
                <Popup content={
                    <form onSubmit={handleSubmit}>
                        <h2 className="mb-3">
                            {popUp === 1 ? "Add" : popUp === 2 ? "Modify" : "Delete"} Faculty
                        </h2>
                        <div className="mb-3">
                            <label
                                className="form-label"
                                for="pid"
                            >PID</label>
                            <input
                                type="text"
                                className="form-control"
                                id="pid"
                                name="pid"
                                value={faculty.pid}
                                onChange={handleChange}
                                disabled={popUp !== 1}
                            />
                        </div>
                        <div className="mb-3">
                            <label
                                className="form-label"
                                for="first"
                            >First Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="first"
                                name="first"
                                value={faculty.first}
                                onChange={handleChange}
                                disabled={popUp === 3}
                            />
                        </div>
                        <div className="mb-3">
                            <label
                                className="form-label"
                                for="last"
                            >Last Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="last"
                                name="last"
                                value={faculty.last}
                                onChange={handleChange}
                                disabled={popUp === 3}
                            />
                        </div>
                        <div className="mb-3">
                            <label
                                className="form-label"
                                for="email"
                            >Email</label>
                            <input
                                type="text"
                                className="form-control"
                                id="email"
                                name="email"
                                value={faculty.email}
                                onChange={handleChange}
                                disabled={popUp === 3}
                            />
                        </div>
                        <div className="mb-3 form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="cs_department"
                                name="cs_department"
                                checked={faculty.cs_department}
                                onChange={handleChange}
                                disabled={popUp === 3}
                            />
                            <label
                                className="form-check-label"
                                for="cs_department"
                            >Is a CS faculty member</label>
                        </div>
                        <div class="popup-button-div">
                            <button
                                type="submit"
                                className={`btn btn-${popUp === 1 ? "success" : popUp === 2 ? "warning" : "danger"}`}
                                onClick={() => {
                                    if(popUp === 1) {
                                    } else if(popUp === 2) {
                                    } else if(popUp === 3) {}
                                }}
                            >
                                {popUp === 1 ? "Add" : popUp === 2 ? "Modify" : "Delete"}
                            </button>
                        </div>
                    </form>
                } handleClose={() => setPopUp(0)} />
            }
        </div>
    );
};

export default FacultyAdminPage;